// extracted by mini-css-extract-plugin
export default {"button":"FlFMy _3cgKO _2AZKg","title":"_321qr"};